module.exports = __webpack_public_path__ + "img/m-banner-vbrohihj-th-TH.079ad969.jpg";